import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { updateBrand } from "../../store/slices/brands";
import MainNavigation from "../../components/navigation/MainNavigation";
import ArticleValueModal from "../../components/modals/EditBrandModal/submodals/ArticleValueModal";
import "./Current.scss";

const ArticleValue = () => {
  const dispatch = useAppDispatch();
  const currentBrand = useSelector((state: any) => state.currentBrand.data);
  const brandId = currentBrand?.domain;
  const brandName = currentBrand?.brandName;

  const [localArticleValueSettings, setLocalArticleValueSettings] = useState({
    totalScorePath: 'customStatistics.total_score',
    sections: []
  });

  useEffect(() => {
    setLocalArticleValueSettings(currentBrand?.articleValueSettings || {
      totalScorePath: 'customStatistics.total_score',
      sections: []
    });
  }, [currentBrand]);

  useEffect(() => {
    document.title = "Article Value Configuration - Smartocto real-time";
    document.body.dataset.titleReady = "true";
  }, []);

  const handleSave = async (data: any) => {
    if (!brandId) return;

    setLocalArticleValueSettings(data);

    try {
      // Update the brand with new article value settings
      await dispatch(updateBrand(brandId, {
        articleValueSettings: data
      }));
    } catch (err) {
      console.error("Error saving article value settings:", err);
    }
  };

  return (
    <>
      <MainNavigation />
      <div className="page-container-no-side-nav">
        <div className="article-value-page">
          {brandId && (
            <ArticleValueModal
              brandId={brandId}
              brandName={brandName}
              data={localArticleValueSettings}
              onSave={handleSave}
              onClose={() => { }}
              hideActions={true}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ArticleValue;